import { AutomationRuleTriggersEnum } from 'modules/automation-rules/triggers/enums/trigger-enum'
import { FUNNEL_STEP_API } from 'modules/funnels/funnel/api/funnel-api'
import { FunnelStepId } from 'modules/funnels/funnel/types/funnel-step-interface'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useUser from 'shared/hooks/use-user'
import useSWR from 'swr'

export const useFunnelStepTriggers = (funnelStepId?: FunnelStepId) => {
  const { user } = useUser()
  const { fetcher } = useFetch<RequestMethodsEnum.get, AutomationRuleTriggersEnum[]>({
    method: RequestMethodsEnum.get,
  })

  return useSWR(() => {
    if (!user || !funnelStepId) return
    return `${FUNNEL_STEP_API}/${funnelStepId}/automation-rule-triggers`
  }, fetcher)
}
